/**
 * 비밀번호 보안 수준 — 가입 화면 안내용 (2026-10-26).
 *
 * 가입 가능 여부는 최소 길이(6자, Firebase Auth 하한·관리자 화면과 같음)만 본다.
 * 이 점수는 "더 안전하게 만들도록" 보여 주는 안내일 뿐 막지 않는다.
 *
 * 점수: 8자 이상 +1 · 12자 이상 +1 · 문자 종류(영문 소문자·대문자·숫자·특수문자) 2종 이상 +1 · 3종 이상 +1
 *   6자 미만 → 약함(가입 불가 길이) / 0~1 약함 / 2~3 보통 / 4 강함
 */
export const PASSWORD_MIN_LENGTH = 6;

export type PasswordStrengthLevel = 0 | 1 | 2 | 3;

export interface PasswordStrength {
  /** 0 = 입력 없음, 1 약함, 2 보통, 3 강함 */
  level: PasswordStrengthLevel;
  label: "" | "약함" | "보통" | "강함";
}

export function passwordStrength(pw: string): PasswordStrength {
  if (!pw) return { level: 0, label: "" };
  if (pw.length < PASSWORD_MIN_LENGTH) return { level: 1, label: "약함" };
  const kinds = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/].filter((re) => re.test(pw)).length;
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (kinds >= 2) score++;
  if (kinds >= 3) score++;
  if (score >= 4) return { level: 3, label: "강함" };
  if (score >= 2) return { level: 2, label: "보통" };
  return { level: 1, label: "약함" };
}
